import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const KeyValueItemWrapper = styled.div`
  width: 100%;
  background: ${GrayColors["G-0"]};
  display: flex;
  gap: 14px;
  &:nth-child(1) {
    display: flex;
    flex-basis: 70%;
  }
`;

export const KeyValueItemContainer = styled.div<{ flexBasis: number }>`
  display: flex;
  width: 100%;
  min-width: 0;
  flex-basis: ${({ flexBasis }) => flexBasis}%;
`;

export const ArrowDivider = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 16px;
  min-width: 16px;
  color: ${GrayColors["G-8"]};
  margin-bottom: 16px;
`;

export const RemoveButton = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  opacity: 0.4;
  width: 30px;
  margin-bottom: 16px;

  &:hover {
    opacity: 1;
  }
`;

export const RequiredSection = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
  white-space: nowrap;
`;

export const RequiredText = styled.div`
  cursor: pointer;
  font-size: 12px;
  color: ${GrayColors["G-8"]};
`;
